export default function IsValidName(name) {
  return name && typeof name === 'string'
    && name.replace(/[\d ]/g, '').length >= 3;
}
